export class MapUtils {
  static equals(map1, map2: Map<string, any>): boolean {
    if (!map1 || !map2) {
      return !map1 && !map2;
    }
    let testVal;
    if (map1.size !== map2.size) {
      return false;
    }
    for (const [key, val] of map1) {
      testVal = map2.get(key);
      if (JSON.stringify(testVal) !== JSON.stringify(val) || (testVal === undefined && !map2.has(key))) {
        return false;
      }
    }
    return true;
  }
}
